import { GoogleLogin } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import GoogleIcon from '@mui/icons-material/Google';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { ESTE_DEV, CONTURI_TEST, tokenTest } from '../dev/testLogin';

function LoginForm({ onLogin }) {
  const [scroll] = React.useState('paper');
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSuccess = credentialResponse => {
    const token = credentialResponse.credential;
    localStorage.setItem("token", token);
    const data = jwt_decode(token);
    const provider = data.hd;
    if (
      provider !== 'stud.ase.ro' &&
      provider !== 'csie.ase.ro' &&
      provider !== 'ie.ase.ro' &&
      provider !== 'ase.ro'
    )
      toast.error('Utilizați un e-mail instituțional!');
    else {
      onLogin(provider);
    }
  };

  // login de test (doar local): pune tokenul de test si autentifica, fara Google
  const loginTest = (cont) => {
    localStorage.setItem('token', tokenTest(cont));
    onLogin(cont.email.split('@')[1]);
  };

  const navigate = useNavigate();
  const [isLoggedin, setIsLoggedin] = useState(false);

  useEffect(() => {

  }, []);

  useEffect(() => {
    if (isLoggedin) {
      navigate("/");
    }
  }, [isLoggedin, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh', marginTop: "50px" }}>
        <CssBaseline />
        <Grid item xs={false} sm={2} md={3} />
        <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6}>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <GoogleIcon />
            </Avatar>
            <Typography align="center" component="h4" variant="h4">
              Înscriere susținere licență
            </Typography>
            <Typography
              align="center"
              sx={{ mt: 2, mb: 10 }}
              component="h5"
              variant="h5"
            >
              Colaborezi rapid și ușor cu un profesor coordonator.
            </Typography>
            <Typography align="center" component="p" variant="p" mb={3}>
              Autentifică-te prin contul tău instituțional.
            </Typography>
            <GoogleLogin
                onSuccess={onSuccess}
                onError={() => {
                  console.log('Login Failed');
                }}
              />
            {ESTE_DEV && (
              <Box
                sx={{
                  mt: 3, width: '100%', maxWidth: 360, p: 2,
                  border: '1px dashed', borderColor: 'warning.main', borderRadius: 1,
                  display: 'flex', flexDirection: 'column', gap: 1,
                }}
              >
                <Typography align="center" component="p" variant="caption" color="warning.main">
                  Autentificare de test — doar local, nu apare în producție.
                </Typography>
                {CONTURI_TEST.map((cont) => (
                  <Button
                    key={cont.email}
                    variant="outlined"
                    size="small"
                    onClick={() => loginTest(cont)}
                  >
                    {cont.eticheta}
                  </Button>
                ))}
              </Box>
            )}
            <Box component="form" noValidate>
              <div>
                <Typography
                  sx={{ mt: 3 }}
                  align="center"
                  component="p"
                  variant="p"
                >
                  <b>
                    <i>
                      Prin autentificarea pe acest site, sunteți de <br></br>{' '}
                      acord cu termenii și condițiile de mai jos.
                    </i>
                  </b>
                </Typography>
                <Button
                  sx={{ mt: 0 }}
                  fullWidth
                  variant="text"
                  onClick={handleClickOpen}
                >
                  Termeni și condiții
                </Button>
                <Dialog
                  fullScreen={fullScreen}
                  open={open}
                  scroll={scroll}
                  onClose={handleClose}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle color="black" id="responsive-dialog-title">
                    Termeni și condiții
                  </DialogTitle>
                  <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText>
                      <b>
                        {' '}
                        Vă rugăm să vă înregistrați doar dacă sunteți cadru
                        didactic în cadrul Departamentului de Informatică și
                        Cibernetică Economică al C.S.I.E. sau student în anul
                        III de studii (ori an suplimentar).
                      </b>
                      <br></br>
                      <br></br>
                      Prin autentificarea în cadrul aplicației sunteți de acord
                      ca aceasta să vă utilizeze datele personale necesare
                      procesului de colaborare pentru elaborarea lucrării de
                      licență, atât ca student, cât și ca profesor. Academia de
                      Studii Economice nu poate fi trasă la răspundere pentru
                      divulgarea accidentală a datelor personale înregistrate la
                      nivelul aplicației în urma unui atac informatic sau a unei
                      breșe de securitate.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleClose(true)}
                      autoFocus
                    >
                      OK
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
              <lottie-player
                src="https://assets6.lottiefiles.com/packages/lf20_kgotdjba.json"
                background="transparent"
                speed="1"
                style={{ width: '300px', height: '200px' }}
                loop
                autoplay
              ></lottie-player>
            </Box>
          </Box>
          <footer className="footer">
            <Typography align="center" component="p" variant="p" sx={{ mb: 2 }}>
              © Iancu Cristina, Dragomir Radu, Constantinescu Vlad
            </Typography>
            <Typography align="center" component="p" variant="p" sx={{ mb: 2 }}>
              Departamentul de Informatică și Cibernetică Economică <br></br>
              (www.dice.ase.ro)
            </Typography>
          </footer>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
export default LoginForm;
